import style from './style.module.css';

export default function Loader() {
  return (
    <span className="m-36">
      <span
        className={`${style.loader} w-3 h-3 md:w-4 md:h-4 dark:[--loader-bg:#101828] dark:[--loader-muted:#1f2937] dark:[--loader-fg:#6b8bff]`}
      ></span>
    </span>
  );
}

export function LoaderBtn() {
  return (
    <span
      className={`${style.loaderBtn} w-3 h-3 dark:[--loader-btn-bg:#101828] dark:[--loader-btn-muted:#1f2937] dark:[--loader-btn-fg:#6b8bff]`}
    ></span>
  );
}

export function LoaderBtnDelete() {
  return (
    <span
      className={`${style.loaderBtnDelete} w-3 h-3 dark:[--loader-del-bg:#101828] dark:[--loader-del-muted:#1f2937] dark:[--loader-del-fg:#e9455f]`}
    ></span>
  );
}
